import { memo } from 'react';

const MapLegend = memo(() => {
  return (
    <div className="hidden md:block absolute bottom-20 right-4 z-[400] bg-background/95 border border-border rounded-lg shadow px-3 py-2">
      <div className="flex gap-3 text-sm text-foreground">
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full bg-orange-500"></div>
          <span>OrangeLabel</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full" style={{backgroundColor:'#0891B2'}}></div>
          <span>BTCMap</span>
        </div>
        <div className="flex items-center gap-1.5">
          <div className="w-3 h-3 rounded-full bg-violet-500"></div>
          <span>ATM</span>
        </div>
      </div>
    </div>
  );
});

export default MapLegend;
